export default {
  new: { label: "New", color: "#2db7f5", order: 10 },
  approve: { label: "Approved", color: "#108ee9", order: 20 },
  reject: { label: "Rejected", color: "#f16b29", order: 30 },
  complete: { label: "Completed", color: "#87d068", order: 40 },
};
